import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { TabOptions } from 'src/app/_models/tab-options';
import { RouterLinkActive, RouterLink } from '@angular/router';

@Component({
    selector: 'app-option-tab-toggle',
    templateUrl: './option-tab-toggle.component.html',
    styleUrls: ['./option-tab-toggle.component.scss'],
    imports: [RouterLinkActive, RouterLink],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OptionTabToggleComponent {
  title: 'OptionTabToggle';
  component: '';

  /** Radio group name (required) */
  radioGroup = input<string>();

  /** What value and text for each button (required) */
  selectOptions = input<TabOptions[]>([]);

  /** What type of button (optional) */
  type = input<'round' | 'square'>('round');
}
